import { CommonModule } from "@angular/common";
import { Component, input } from "@angular/core";

type SkeletonVariant = "text" | "horizontal-card" | "card" | "avatar" | "table-row";
type SkeletonSize = "xs" | "sm" | "md" | "lg";

@Component({
  selector: "app-skeleton",
  template: `
    <div 
      *ngIf="visible()" 
      class="skeleton" 
      [ngClass]="[variant(), size()]">
    </div>
  `,
  styleUrls: ["./skeleton.component.scss"],
  imports: [CommonModule],
  standalone: true
})
export class SkeletonComponent {
  visible = input<boolean>(true);
  variant = input<SkeletonVariant>("text");
  size = input<SkeletonSize>("md");
}